import { FieldTimeOutlined } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';
import moment from 'moment';
import { useMemo } from 'react';
import styled from 'styled-components';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Shows the deadline using a Tag component.
 * The color of the deadline depends on the time left.
 * @param props
 */
export var TaskDeadline = function TaskDeadline(_ref) {
  var deadline = _ref.deadline;
  var time = useMemo(function () {
    return moment(deadline).fromNow();
  }, [deadline]);
  var formattedDate = useMemo(function () {
    return moment(deadline).format('DD/MM/YYYY HH:mm');
  }, [deadline]);
  var color = useMemo(function () {
    var deadlineDate = moment(deadline);
    var now = moment();

    if (now.isAfter(deadlineDate)) {
      return 'red';
    }

    var daysLeft = deadlineDate.diff(now, 'days');

    if (daysLeft < 1) {
      return 'orange';
    }

    if (daysLeft < 3) {
      return 'yellow';
    }

    return 'green';
  }, [deadline]);

  if (!deadline) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsx(Container, {
    title: formattedDate,
    className: "TaskDeadline",
    children: /*#__PURE__*/_jsx(Tag, {
      icon: /*#__PURE__*/_jsx(FieldTimeOutlined, {}),
      color: color,
      children: time
    })
  });
}; // Styles

var Container = styled(Tooltip).withConfig({
  displayName: "Deadline__Container",
  componentId: "sc-1a46egq-0"
})(["width:150px;text-overflow:ellipsis;overflow:hidden;text-align:center;"]);